import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import camelize from 'camelize';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useParams, useRouteMatch, } from 'react-router-dom';
import { CREDIT_PORTAL_URL, makePath } from 'shared';
import { toastError } from 'utils';
import { setToken } from './slice';
import * as Views from './views';
function Routes() {
    const { path } = useRouteMatch();
    const dispatch = useDispatch();
    const { receiptIdEncoded } = useParams();
    const history = useHistory();
    const token = useSelector((state) => state.root.creditPortal.receipt.token);
    useEffect(() => {
        try {
            const receiptInfoDecoded = camelize(JSON.parse(atob(receiptIdEncoded ?? '')));
            receiptInfoDecoded &&
                dispatch(setToken(receiptInfoDecoded.emailToken ??
                    receiptInfoDecoded.smsToken ??
                    receiptInfoDecoded.embeddedToken));
        }
        catch (e) {
            toastError('Invalid Receipt URL');
            history.push(CREDIT_PORTAL_URL);
        }
    }, []);
    if (receiptIdEncoded === null) {
        history.push(CREDIT_PORTAL_URL);
        return _jsx(_Fragment, {});
    }
    if (!token) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(Switch, { children: [_jsx(Route, { exact: true, path: makePath(path, '/success'), children: _jsx(Views.ESignSuccess, {}) }), _jsx(Route, { path: makePath(path, '/transaction-voided'), children: _jsx(Views.ESignErrorBecauseOfStatus, { status: "voided" }) }), _jsx(Route, { path: makePath(path, '/transaction-canceled'), children: _jsx(Views.ESignErrorBecauseOfStatus, { status: "canceled" }) }), _jsx(Route, { path: path, children: _jsx(Views.ESign, {}) })] }));
}
export default Routes;
